import Index from "../pages/Index.vue"
// import Login from "../pages/Login.vue"
import NotFound from "../pages/NotFound.vue"
import MeetingList from "../pages/meeting/List.vue"
import MeetingSchedule from "../pages/meeting/Schedule.vue"
import MeetingHistory from "../pages/meeting/History.vue"
import MeetingDetail from "../pages/meeting/Detail.vue"
import MeetingReserve from "../pages/meeting/Reserve.vue"
import RoomList from "../pages/room/List.vue"
import RoomDetail from "../pages/room/Detail.vue"
import DirectReserve from "../pages/room/DirectReserve.vue"
import CheckinDetail from "../pages/checkin/Detail.vue"
import CheckinRecordList from "../pages/checkin/RecordList.vue"
import UserPanel from "../pages/user/UserPanel.vue"
import FrequentContact from "../pages/user/FrequentContact.vue"
import ServiceList from "../pages/user/ServiceList.vue"
import Setting from "../pages/user/Setting.vue"
import CallService from "../pages/operation/CallService.vue"
import DeviceControl from "../pages/operation/DeviceControl.vue"
import RoomControl from "../pages/operation/RoomControl.vue"
import RepairList from "../pages/user/RepairList.vue"
import PersonalGroup from "../pages/user/PersonalGroup.vue"
import SetPersonalGroup from "../pages/user/SetPersonalGroup.vue"

import {formatRootPath} from "../../../tools/utils";

const destPath = (path) => formatRootPath("/front") + path;

export default {
  // login: {
  //   path: destPath('/login'),
  //   name: 'front.login',
  //   title: '登录',
  //   component: Login,
  // },
  notFound: {
    path: destPath('/not-found'),
    name: 'front.notFound',
    title: '访问的页面不存在',
    parent: '',
    component: NotFound,
  },
  home: {
    path: destPath('/'),
    name: 'front.home',
    title: '首页',
    backRt: 'front.home',
    component: Index,
  },
  homeReplace: {
    path: destPath('/home'),
    name: 'front.home.replace',
    title: '首页',
    backRt: 'front.home',
    component: Index,
  },
  meetingReserveFromHome: {
    path: destPath('/home/meeting/reserve'),
    name: 'front.home.meeting.reserve',
    title: '会议预约',
    backRt: 'front.home',
    component: MeetingReserve,
  },
  meetingDetailFromHome: {
    path: destPath('/home/meeting/detail/:mid'),
    name: 'front.home.meeting.detail',
    title: '会议详情',
    backRt: 'front.home',
    mtBack: true,
    component: MeetingDetail,
  },
  meetingCheckin: {
    path: destPath('/meeting/checkin/:mid'),
    name: 'front.meeting.checkin',
    title: '会议签到',
    mtBack: true,  // 仅用于签到记录页面返回
    component: CheckinDetail,
  },
  checkinRecordList: {
    path: destPath('/meeting/checkin-record/:mid'),
    name: 'front.meeting.checkin-record',
    title: '会议签到记录',
    component: CheckinRecordList,
  },
  roomReserve: {
    path: destPath('/room/reserve/:rid'),
    name: 'front.room.reserve',
    title: '会议预约',
    component: DirectReserve,
  },
  mgrRoomReserve: {
    path: destPath('/room/qrcode/:mgrid'),
    name: 'front.qrcode.reserve',
    title: '会议预约',
    component: DirectReserve,
  },

  meetingList: {
    path: destPath('/meeting'),
    name: 'front.meeting',
    title: '会议列表',
    backRt: 'front.home',
    component: MeetingList,
    keepAlive: true
  },
  meetingReserve: {
    path: destPath('/meeting/reserve'),
    name: 'front.meeting.reserve',
    title: '会议预约',
    component: MeetingReserve,
  },
  tlcReserve: {
    path: destPath('/tlc/reserve'),
    name: 'front.tlc.reserve',
    title: '云会议预约',
    backRt: 'front.schedule',
    component: MeetingReserve,
  },
  meetingDetail: {
    path: destPath('/meeting/detail/:mid'),
    name: 'front.meeting.detail',
    title: '会议详情',
    backRt: 'front.meeting',
    mtBack: true,
    component: MeetingDetail,
  },
  meetingReserveFromMtDetail: {
    path: destPath('/meeting/detail/:cmid/reserve'),
    name: 'front.meeting.copy.reserve',
    title: '再约一场',
    component: MeetingReserve,
  },
  meetingEdit: {
    path: destPath('/meeting/edit/:mid'),
    name: 'front.meeting.edit',
    title: '编辑会议',
    component: MeetingReserve,
  },
  periodicMeetingEdit: {
    path: destPath('/periodic-meeting/edit/:mid'),
    name: 'front.periodic_meeting.edit',
    title: '编辑会议',
    component: MeetingReserve,
  },
  meetingHistoryList: {
    path: destPath('/meeting/history'),
    name: 'front.meeting.history',
    title: '历史会议',
    component: MeetingHistory,
    keepAlive: true
  },
  meetingDetailFromHistory: {
    path: destPath('/meeting/history/detail/:mid'),
    name: 'front.meeting.history.detail',
    title: '会议详情',
    backRt: 'front.meeting.history',
    mtBack: true,
    component: MeetingDetail,
  },
  meetingSchedule: {
    path: destPath('/schedule'),
    name: 'front.schedule',
    title: '我的日程',
    backRt: 'front.home',
    component: MeetingSchedule,
  },
  meetingReserveFromSch: {
    path: destPath('/schedule/meeting/reserve'),
    name: 'front.schedule.meeting.reserve',
    title: '会议预约',
    backRt: 'front.schedule',
    component: MeetingReserve,
  },
  meetingDetailFromSch: {
    path: destPath('/schedule/meeting/detail/:mid'),
    name: 'front.schedule.meeting.detail',
    title: '会议详情',
    backRt: 'front.schedule',
    mtBack: true, // 可返回会议
    component: MeetingDetail,
  },

  roomList: {
    path: destPath('/room'),
    name: 'front.room',
    title: '会议室列表',
    backRt: 'front.home',
    component: RoomList,
    keepAlive: true
  },
  roomDetail: {
    path: destPath('/room/detail/:rid'),
    name: 'front.room.detail',
    title: '会议室详情',
    component: RoomDetail,
  },
  meetingDetailFromRoom: {
    path: destPath('/room/detail/:rid/meeting/:mid'),
    name: 'front.room.meeting.detail',
    title: '会议详情',
    mtBack: true,
    component: MeetingDetail,
  },
  meetingReserveFromRoom: {
    path: destPath('/room/detail/:rid/reserve'),
    name: 'front.room.meeting.reserve',
    title: '会议预约',
    component: MeetingReserve,
  },

  userPanel: {
    path: destPath('/user'),
    name: 'front.user',
    title: '个人中心',
    backRt: 'front.home',
    component: UserPanel
  },
  serviceInCharge: {
    path: destPath('/user/charge/service'),
    name: 'front.user.charge.service',
    title: '我负责的服务',
    backRt: 'front.user',
    component: ServiceList,
  },
  serviceInChargeToMtDetail: {
    path: destPath('/user/charge/service/:mid'),
    name: 'front.user.charge.service.meeting.detail',
    title: '会议详情',
    backRt: 'front.user.charge.service',
    mtBack: true,
    component: MeetingDetail,
  },
  selfService: {
    path: destPath('/user/self/service'),
    name: 'front.user.self.service',
    title: '我的服务需求',
    backRt: 'front.user',
    component: ServiceList,
  },
  selfServiceToMtDetail: {
    path: destPath('/user/self/service/:mid'),
    name: 'front.user.self.service.meeting.detail',
    title: '会议详情',
    backRt: 'front.user.self.service',
    mtBack: true,
    component: MeetingDetail,
  },
  selfRepair: {
    path: destPath('/user/self/repair'),
    name: 'front.user.self.repair',
    title: '我提交的报修',
    backRt: 'front.user',
    component: RepairList,
  },
  selfFrequentRoom: {
    path: destPath('/user/frequent/room'),
    name: 'front.user.frequent.room',
    title: '常用会议室',
    backRt: 'front.user',
    component: RoomList,
  },
  selfFrequentContacts: {
    path: destPath('/user/frequent/contacts'),
    name: 'front.user.frequent.contacts',
    title: '常用联系人',
    backRt: 'front.user',
    component: FrequentContact
  },
  selfSetting: {
    path: destPath('/user/setting'),
    name: 'front.user.setting',
    title: '设置',
    backRt: 'front.user',
    component: Setting
  },
  personalGroup: {
    path: destPath('/user/group'),
    name: 'front.user.group',
    title: '会议群组',
    backRt: 'front.user',
    component: PersonalGroup
  },
  newPersonalGroup: {
    path: destPath('/user/group/new'),
    name: 'front.user.group.new',
    title: '新建会议群组',
    backRt: 'front.user.group',
    component: SetPersonalGroup
  },
  editPersonalGroup: {
    path: destPath('/user/group/:psgId'),
    name: 'front.user.group.edit',
    title: '编辑会议群组',
    backRt: 'front.user.group',
    component: SetPersonalGroup
  },

  roomControl: {
    path: destPath('/room/control/:rid'),
    name: 'front.room.control',
    title: '会控/服务',
    component: RoomControl
  },
  callService: {
    path: destPath('/call/service/:mid'),
    name: 'front.call.service',
    title: '会中服务',
    component: CallService
  },
  /*submitRepair: {
    path: destPath('/submit/repair/:rid'),
    name: 'front.submit.repair',
    title: '提交报修',
  },*/
  deviceCtrl: {
    path: destPath('/call/device/control/:rid'),
    name: 'front.device.control',
    title: '设备控制',
    component: DeviceControl
  },
}
